var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.75H6C2.35 21.75 0.25 19.65 0.25 16V6C0.25 2.35 2.35 0.25 6 0.25H14C17.65 0.25 19.75 2.35 19.75 6V16C19.75 19.65 17.65 21.75 14 21.75ZM6 1.75C3.14 1.75 1.75 3.14 1.75 6V16C1.75 18.86 3.14 20.25 6 20.25H14C16.86 20.25 18.25 18.86 18.25 16V6C18.25 3.14 16.86 1.75 14 1.75H6Z",
    fill: "#86929D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.25H14.5C12.98 8.25 11.75 7.02 11.75 5.5V3.5C11.75 3.09 12.09 2.75 12.5 2.75C12.91 2.75 13.25 3.09 13.25 3.5V5.5C13.25 6.19 13.81 6.75 14.5 6.75H16.5C16.91 6.75 17.25 7.09 17.25 7.5C17.25 7.91 16.91 8.25 16.5 8.25Z",
    fill: "#86929D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H10C10.41 11.25 10.75 11.59 10.75 12C10.75 12.41 10.41 12.75 10 12.75Z",
    fill: "#86929D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.75H6C5.59 16.75 5.25 16.41 5.25 16C5.25 15.59 5.59 15.25 6 15.25H14C14.41 15.25 14.75 15.59 14.75 16C14.75 16.41 14.41 16.75 14 16.75Z",
    fill: "#86929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.682bf4d90bf61a75453ff16becd86d2c.svg";
export { ForwardRef as ReactComponent };